import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import {SiLeetcode} from 'react-icons/si'
import {BsInstagram} from 'react-icons/bs'
import {BsMedium} from 'react-icons/bs'


const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href='https://www.linkedin.com/in/ahmad-alamgir-74241a392' target='_blanl'><BsLinkedin/></a>
        <a href='https://www.instagram.com/filmsbyahmad' target='_blanl'><BsInstagram/></a>
        
    </div>
  )
}

export default HeaderSocials